module.exports = __webpack_public_path__ + "static/img/6-4.94a6275.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/6-4.png
// module id = YX5m
// module chunks = 0